/**
 * @author Ariel
 * @Date 2023/2/3
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { WizBraftEditorPlus } from "../../../common";
import { TagSelect } from '@/components'
import './index.less'
let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin, WizTooltip, WizSelect, WizIcon, WizTag, WizButton } = component_tool;
let { Session } = utils_tool

const getParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === '/biz/inviteLetter/update') {
    if (history.location.record) {
      record = history.location.record;
      Session.set('inviteLetterInfo', record)
    } else {
      record = Session.get('inviteLetterInfo') || {};
    }
  }
  return record
}

class InviteLetterEdit extends WizContainer {

  componentName = 'inviteLetterEdit';

  constructor(props) {
    super(props);
    const { history } = props;
    let record = getParamRecord(history)
    this.state = {
      bizType: 15,
      userColumns: {},
      schemaColumns: {},
      inviteParams: [],
      letterId:record.id
    }
    this.record = record;
  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/biz/inviteLetter/update') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('inviteLetterInfo', initialValue)
      } else {
        initialValue = Session.get('inviteLetterInfo') || {};
      }
    }
    if (initialValue.id != this.state.letterId) {
      this.setState({record:initialValue,letterId:initialValue.id})
      this._componentDidMount()
    }
  }

  _componentDidMount() {
    let { history } = this.props
    let record = getParamRecord(history)
    if (record && record.id) {
      this.doAction({
        path: 'inviteLetter/getById',
        payload: {
          key: 'inviteLetterInfo',
          apiParams: { id: record.id }
        }
      })
    }

    // this.doActions([
    //   {
    //     path: 'schemaColumns/userInfo',
    //     payload: {
    //       key: 'getUserColumnsInfo',
    //       apiParams: { }
    //     }
    //   },
    //   {
    //     path: 'schemaColumns/columnsInfo',
    //     payload: {
    //       key: 'getSchemaColumnsInfo',
    //       apiParams: {
    //         databaseName: databaseName,
    //         tableName: tableName
    //       }
    //     }
    //   }
    // ]);
  }

  propsAndStateOnChange = {
    inviteLetterInfo: this._getInviteLetterInfoOver.bind(this),
    addInviteLetter: this._addInviteLetterOver.bind(this),
    userColumnsInfo: this._getUserColumnsInfoOver.bind(this),
    schemaColumnsInfo: this._getSchemaColumnsInfoOver.bind(this),
  }

  _getInviteLetterInfoOver(nextProps, nextState) {
    let { inviteLetterInfo } = nextProps
    if (inviteLetterInfo.code === 1) {
      if (inviteLetterInfo && inviteLetterInfo.success) {
        this.record = inviteLetterInfo.data
        nextState.inviteParams = inviteLetterInfo.data.inviteParams || []
      }
    } else {
      wizNotice.error('获取数据失败：' + nextProps.inviteLetterInfo.msg);
    }
    return true;
  }

  _addInviteLetterOver(nextProps, nextState) {
    if (nextProps.addInviteLetter.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/biz/inviteLetter');
    } else {
      wizNotice.error('提交失败：' + nextProps.addInviteLetter.msg);
    }
    return true;
  }

  _getUserColumnsInfoOver(nextProps, nextState) {
    let { userColumnsInfo } = nextProps
    if (userColumnsInfo.code === 1) {
      if (userColumnsInfo && userColumnsInfo.success) {
        nextState.userColumns = userColumnsInfo.data
      }
    } else {
      wizNotice.error('获取数据失败：' + nextProps.userColumnsInfo.msg);
    }
    return true;
  }

  _getSchemaColumnsInfoOver(nextProps, nextState) {
    let { schemaColumnsInfo } = nextProps
    if (schemaColumnsInfo.code === 1) {
      if (schemaColumnsInfo && schemaColumnsInfo.success) {
        nextState.schemaColumns = schemaColumnsInfo.data
      }
    } else {
      wizNotice.error('获取数据失败：' + nextProps.schemaColumnsInfo.msg);
    }
    return true;
  }


  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  /**
   * @param values
   * @private
   */
  _saveInviteLetter(values) {
    let { inviteParams } = this.state
    if (inviteParams && Array.isArray(inviteParams)) {
      values.inviteParams = inviteParams
    }
    const { history } = this.props;
    let apiPath = "inviteLetter/add";
    if (history.location && history.location.pathname === '/biz/inviteLetter/update') {
      apiPath = "inviteLetter/update"
    }
    let {content} = values
    if (content == '<p></p>' || content == '' || content.trim() == '') {
      wizNotice.error('请输入内容')
      return false
    }
    let fitterValues = this.fitterFieldsValue(values)
    this.doAction({
      path: apiPath,
      payload: {
        key: "addInviteLetter",
        apiParams: {
          ...fitterValues
        }
      }
    });
  }

  // handleSelectOnChange = (value) => {
  //   let {inviteParams} = this.state
  //   if (value && Array.isArray(value)) {
  //     value.forEach(i => {
  //       inviteParams.push(i)
  //     })
  //   }
  //   this.setState({inviteParams: inviteParams})
  // };
  handleSelectOnChange = (value) => {
    this.setState({ inviteParams: value })
  };
  _render() {
    const { inviteLetterLoading } = this.props;
    let { id, content, state, inviteParams } = this.record;

    if (state == undefined || state == null) {
      state = 1
    }

    let columns = [
      {
        formItem: {
          type: "hidden",
          initialValue: id
        },
        name: "id"
      },
      {
        title: "业务类型",
        name: "bizType",
        formItem: {
          type: "select",
          initialValue: this.record.bizType || 15,
          rules: [
            {
              required: true,
              message: '请选择业务类型'
            },
          ],
        },
        dict: [
          { code: 15, codeName: "报名" },
        ],
      },
      {
        title: "标题",
        name: "title",
        formItem: {
          maxlength: 50,
          rules: [
            {
              required: true,
              message: '请输入标题'
            },
          ],
          initialValue: this.record.title
        }
      },
      // {
      //   title: "内容参数信息",
      //   name: 'inviteParams',
      //   formItem: {
      //     type: 'custom',
      //     render: (record, form) => {
      //       const { getFieldDecorator } = form
      //       return (
      //         <>
      //           {getFieldDecorator('inviteParams', {
      //             rules: [{ type: 'array' }],
      //             initialValue: inviteParams || [],
      //           })(
      //             <div>
      //               <WizSelect onBlur={this.handleSelectOnChange}
      //                          mode="multiple"
      //                          defaultValue={inviteParams}
      //               >
      //                 {schemaDict.map((val) => (
      //                   <WizSelect.Option key={val.value} value={val.value}>
      //                     {val.label}
      //                   </WizSelect.Option>
      //                 ))}
      //               </WizSelect>
      //               <span>
      //               <WizTooltip title="邀请函内容中非固定数据展示为***，按顺序选择需填充参数">
      //                 <WizTag color="#f50">邀请函内容中非固定数据展示为***，按顺序选择需填充参数</WizTag>
      //               </WizTooltip>
      //             </span>
      //             </div>
      //           )}
      //         </>
      //       )
      //     }
      //   },
      // },
      {
        title: "内容参数信息",
        name: 'inviteParams',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {getFieldDecorator('inviteParams', {
                  rules: [{ type: 'array' }],
                  initialValue: inviteParams || [],
                })(
                  <div>
                    <TagSelect initialValue={inviteParams} submitTags={this.handleSelectOnChange}></TagSelect>
                    {/* <WizSelect onBlur={this.handleSelectOnChange}
                               mode="multiple"
                               defaultValue={inviteParams}
                    >
                      {schemaDict.map((val) => (
                        <WizSelect.Option key={val.value} value={val.value}>
                          {val.label}
                        </WizSelect.Option>
                      ))}
                    </WizSelect> */}
                    <span>
                      <WizTooltip title="邀请函内容中非固定数据展示为***，按顺序选择需填充参数">
                        <WizTag color="#f50">邀请函内容中非固定数据展示为***，按顺序选择需填充参数</WizTag>
                      </WizTooltip>
                    </span>
                  </div>
                )}
              </>
            )
          }
        },
      },
      {
        title: "内容",
        name: "content",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {getFieldDecorator('content', {
                  initialValue: content && content,
                  rules: [
                    {
                      required: true,
                      message: '请输入内容'
                    },
                  ],
                })(
                  <WizBraftEditorPlus links={[0, 1, 2, 3]} />
                )}
              </>
            )
          }
        },
      },
      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        tableItem: {},
        dict: [
          { code: 1, codeName: '打开' },
          { code: 0, codeName: '关闭' }
        ],
        formItem: {
          initialValue: state,
          type: 'radio',
          rules: [
            {
              required: true,
              message: '请选择状态'
            },
          ],
        }
      },
    ]

    let onSubmit = this._saveInviteLetter.bind(this);

    let formProps = {
      ref: 'form',
      key: this.state.letterId || '', // ⭐如缓存路由需要刷新,必须加标识key
      loading: inviteLetterLoading,
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: (
        <div className='invite-letter-edit-form-btn'>
          <WizButton type='primary' htmlType='submit'>提交</WizButton>
        </div>
      ),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={inviteLetterLoading}>
          <WizForm className='form-inline' {...formProps} />
        </WizSpin>

      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { inviteLetter, schemaColumns } = state;
  const inviteLetterInfo = modelUtils.getModelEntity(inviteLetter, "inviteLetterInfo");
  const addInviteLetter = modelUtils.getModelEntity(inviteLetter, "addInviteLetter");
  const userColumnsInfo = modelUtils.getModelEntity(schemaColumns, "getUserColumnsInfo");
  const schemaColumnsInfo = modelUtils.getModelEntity(schemaColumns, "getSchemaColumnsInfo");
  const load = modelUtils.getLoadingState(state, ['inviteLetter', 'schemaColumns']);
  return {
    inviteLetterInfo: inviteLetterInfo,
    addInviteLetter: addInviteLetter,
    userColumnsInfo: userColumnsInfo,
    schemaColumnsInfo: schemaColumnsInfo,
    ...load
  }
};

export default connect(mapStateToProps)(InviteLetterEdit);
